"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Row = function Row(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      otherProps = _objectWithoutProperties(_ref, ["className", "children", "onClick"]);

  return /*#__PURE__*/_react.default.createElement(Tr, _extends({
    className: className,
    onClick: onClick
  }, otherProps), children);
};

var Tr = _styledComponents.default.tr.withConfig({
  displayName: "Tr"
})(["background-color:white;font-size:1.6rem;vertical-align:middle;:hover{background-color:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.brand.lightest;
});

Row.defaultProps = {
  otherProps: {}
};
Row.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** Adds extra props to the element */
  otherProps: _propTypes.object,
  onClick: _propTypes.func,
  children: _propTypes.node
};
var _default = Row;
exports.default = _default;